(ns frontend.bootstrap.components
  (:require [reagent.core :as r]
            ["react-bootstrap" :as react-bootstrap]))

(defn adapt
  ([cls-name]
   (r/adapt-react-class (aget react-bootstrap cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (aget (aget react-bootstrap parent-cls) cls-name))))

(def Accordion (adapt "Accordion"))
(def Alert (adapt "Alert"))
(def Badge (adapt "Badge"))
(def Breadcrumb (adapt "Breadcrumb"))
(def BreadcrumbItem (adapt "BreadcrumbItem"))
(def Button (adapt "Button"))
(def ButtonGroup (adapt "ButtonGroup"))
(def ButtonToolbar (adapt "ButtonToolbar"))
(def Card (adapt "Card"))
(def CardColumns (adapt "CardColumns"))
(def CardDeck (adapt "CardDeck"))
(def CardGroup (adapt "CardGroup"))
(def CardImg (adapt "CardImg"))
(def Card-Body (adapt "Card" "Body"))
(def Card-Header (adapt "Card" "Header"))
(def Card-Footer (adapt "Card" "Footer"))
(def Carousel (adapt "Carousel"))
(def CarouselItem (adapt "CarouselItem"))
(def CloseButton (adapt "CloseButton"))
(def Col (adapt "Col"))
(def Collapse (adapt "Collapse"))
(def Container (adapt "Container"))
(def Dropdown (adapt "Dropdown"))
(def Dropdown-Header (adapt "Dropdown" "Header"))
(def Dropdown-Menu (adapt "Dropdown" "Menu"))
(def Dropdown-Toggle (adapt "Dropdown" "Toggle"))
(def DropdownButton (adapt "DropdownButton"))
(def DropdownItem (adapt "Dropdown" "Item"))
(def DropdownDivider (adapt "Dropdown" "Divider"))
(def Fade (adapt "Fade"))
(def Figure (adapt "Figure"))
(def Form (adapt "Form"))
(def FormCheck (adapt "FormCheck"))
(def FormControl (adapt "FormControl"))
(def FormGroup (adapt "FormGroup"))
(def FormLabel (adapt "FormLabel"))
(def FormText (adapt "FormText"))
(def Image (adapt "Image"))
(def InputGroup (adapt "InputGroup"))
(def Jumbotron (adapt "Jumbotron"))
(def ListGroup (adapt "ListGroup"))
(def ListGroupItem (adapt "ListGroupItem"))
(def Media (adapt "Media"))
(def Modal (adapt "Modal"))
(def ModalBody (adapt "ModalBody"))
(def ModalDialog (adapt "ModalDialog"))
(def ModalFooter (adapt "ModalFooter"))
(def ModalTitle (adapt "ModalTitle"))
(def Modal-Header (adapt "Modal" "Header"))
(def Nav (adapt "Nav"))
(def Navbar (adapt "Navbar"))
(def NavbarBrand (adapt "NavbarBrand"))
(def NavDropdown (adapt "NavDropdown"))
(def NavItem (adapt "NavItem"))
(def Overlay (adapt "Overlay"))
(def OverlayTrigger (adapt "OverlayTrigger"))
(def PageItem (adapt "PageItem"))
(def Pagination (adapt "Pagination"))
(def Popover (adapt "Popover"))
(def PopoverTitle (adapt "PopoverTitle"))
(def PopoverContent (adapt "PopoverContent"))
(def ProgressBar (adapt "ProgressBar"))
(def ResponsiveEmbed (adapt "ResponsiveEmbed"))
(def Row (adapt "Row"))
(def SafeAnchor (adapt "SafeAnchor"))
(def Spinner (adapt "Spinner"))
(def SplitButton (adapt "SplitButton"))
(def Tab (adapt "Tab"))
(def TabContainer (adapt "TabContainer"))
(def TabContent (adapt "TabContent"))
(def Table (adapt "Table"))
(def TabPane (adapt "TabPane"))
(def Tabs (adapt "Tabs"))
(def ThemeProvider (adapt "ThemeProvider"))
(def Toast (adapt "Toast"))
(def ToastBody (adapt "ToastBody"))
(def ToastHeader (adapt "ToastHeader"))
(def ToggleButton (adapt "ToggleButton"))
(def ToggleButtonGroup (adapt "ToggleButtonGroup"))
(def Tooltip (adapt "Tooltip"))

